import React, { useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
    OrdersContainer,
    OrderContainer,
    BottomBar,
} from './OrdersCardView.styled';
import {
    getCardData,
    setFilters,
    setSelectedDate,
} from 'src/pages/home/redux/actions';
import { getShortMonthName, getFullDayName } from 'src/utils/dateUtils';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Order from '../order/Order';
import OrderDateCaseHeader from '../ordersDateCaseHeader/OrdersDateCaseHeader';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ArrowLeft from 'src/assets/images/ArrowLeftLight.svg';
import ArrowRight from 'src/assets/images/ArrowRightLight.svg';
import NoCaseScheduleSurgery from '../noCaseScheduleSurgery/NoCaseScheduleSurgery';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { convertDateToISOString, prevEndDate, prevStartDate } from 'src/utils/util';
import { getEndDateForStartDate, getEndOfTimeDate } from 'src/utils/dateUtils';
import OrdersSearchResults from '../ordersSearchResults/OrdersSearchResults';
import SearchResultsPanel from 'src/pages/home/component/orders/searchResultsPanel/SearchResultsPanel';
import { sizes } from 'src/styles/Media.styled';
import OrderDetails from 'src/pages/orders/components/orderDetails/OrderDetails';
import {
    closeOrderSummaryModalState,
    setItemListView,
} from 'src/pages/orders/redux/actions';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrdersCardView = (props) => {
    const { t } = useTranslation();
    let {
        orders,
        viewDataSurgeryDatesReducer,
        startDateISOString,
        endDateISOString,
        searchParam,
    } = useSelector((state) => ({
        orders: state.ordersReducer.cardData.orderData,
        viewDataSurgeryDatesReducer: state.ordersReducer.viewData.surgeryDates,
        startDateISOString: state.filterReducer.userFilters.startDate,
        endDateISOString: state.filterReducer.userFilters.endDate,
        searchParam: state.filterReducer.searchParam,
    }));

    const userFilters = useSelector(
        (state) => state.filterReducer.userFilters,
        shallowEqual
    );
    const searchCardData = useSelector(
        (state) => state.ordersReducer.searchCardData.orderData,
        shallowEqual
    );
    const [viewDataSurgeryDates, setViewDataSurgeryDates] = useState([]);
    const isViewDataLoading = useSelector(
        (state) => state.ordersReducer.viewDataLoading
    );
    const isAdditionalViewDataLoading = useSelector(
        (state) => state.ordersReducer.additionalViewDataLoading
    );

    let selectedDate = useSelector((state) => state.filterReducer.selectedDate);
    const businessDays = useSelector(
        (state) => state.filterReducer.lastThreeBusinessDays
    );

    const dispatch = useDispatch();

    const currentDate = new Date();

    const cardDataLoading = useSelector(
        (state) => state.ordersReducer.cardDataLoading
    );

    const searchCardDataLoading = useSelector(
        (state) => state.ordersReducer.searchCardDataLoading
    );

    // const prevStartDateRef = React.useRef(startDateISOString);
    // const prevEndDateRef = React.useRef(endDateISOString);

    useEffectWithErrorLogging(() => {
        if (
            startDateISOString !== prevStartDate.current ||
            endDateISOString !== prevEndDate.current
        ) {
            if (!startDateISOString) return;
            dispatch(
                getCardData({
                    ...userFilters,
                })
            );            
        }
        prevStartDate.current = startDateISOString;
        prevEndDate.current = endDateISOString;

        return ()=>{
            prevStartDate.current = null;
            prevEndDate.current = null;
        };
    }, [startDateISOString, endDateISOString]);

    // useEffectWithErrorLogging(() => {
    //     if (!startDate || !endDate) return;
    //     dispatch(
    //         getCardData({
    //             ...orderfilters,
    //             startDate: convertDateToISOString(startDate, 'start'),
    //             endDate: convertDateToISOString(endDate, 'end'),
    //         })
    //     );

    //     // dispatch(getViewFilter({ fields: 'BASIC' }));
    // }, [startDate, endDate]);

    selectedDate = new Date(selectedDate.toDateString());

    useEffectWithErrorLogging(() => {
        dispatch(
            setFilters({
                sortParam: 'surgeryStartDate',
                sortOrder: 'ASC',
            })
        );
    }, []);

    useEffectWithErrorLogging(() => {
        if ((viewDataSurgeryDatesReducer || []).length) {
            let tempViewDataSurgeryDates = viewDataSurgeryDatesReducer.map(
                (item) => {
                    return new Date(item).toDateString();
                }
            );
            let tempViewDataSurgeryDatesSet = [
                ...new Set(tempViewDataSurgeryDates),
            ];
            if (tempViewDataSurgeryDatesSet.length)
                setViewDataSurgeryDates(
                    tempViewDataSurgeryDatesSet.map((item) => new Date(item))
                );
        }
    }, [viewDataSurgeryDatesReducer]);

    const isSelectedDateGtFromCurrentDate =
        new Date(selectedDate) >= new Date(currentDate.toDateString());
    const isLastOrder =
        (viewDataSurgeryDates || []).findIndex((surgeryDate) => {
            return (
                surgeryDate.setHours(0, 0, 0, 0) >=
                new Date(selectedDate).setHours(0, 0, 0, 0)
            );
        }) === 0;
    const showNextButton =
        new Date(selectedDate).setHours(0, 0, 0, 0) >=
        viewDataSurgeryDates[viewDataSurgeryDates?.length - 1];

    orders = (orders || []).map((order) => {
        return {
            ...order,
            surgeryStartDateAtMidnight: new Date(order.surgeryStartDate),
        };
    });

    const isSelectedDateHaveOrders =
        orders.filter((order) => {
            return (
                order.surgeryStartDateAtMidnight.setHours(0, 0, 0, 0) ===
                new Date(selectedDate).setHours(0, 0, 0, 0)
            );
        }).length > 0;

    const previousButtonHandler = () => {
        let indexOfSurgeryDateBeforeSelectedDate =
            viewDataSurgeryDates.findIndex((surgeryDate) => {
                return (
                    surgeryDate >= new Date(selectedDate).setHours(0, 0, 0, 0)
                );
            });

        indexOfSurgeryDateBeforeSelectedDate =
            indexOfSurgeryDateBeforeSelectedDate < 0
                ? viewDataSurgeryDates.length - 1
                : indexOfSurgeryDateBeforeSelectedDate - 1;

        const newStartDate =
            viewDataSurgeryDates[indexOfSurgeryDateBeforeSelectedDate];

        const newEndDate =
            new Date(newStartDate).setHours(0, 0, 0, 0) >=
            new Date(currentDate.setHours(0, 0, 0, 0))
                ? ''
                : viewDataSurgeryDates[indexOfSurgeryDateBeforeSelectedDate];

        dispatch(
            setFilters({
                startDate: convertDateToISOString(
                    new Date(newStartDate),
                    'start'
                ),
                endDate: convertDateToISOString(new Date(newEndDate), 'end'),
            })
        );
        dispatch(setSelectedDate(new Date(newStartDate)));
    };

    const nextButtonHandler = () => {
        let indexOfSurgeryDateAfterSelectedDate =
            viewDataSurgeryDates.findIndex((surgeryDate) => {
                return (
                    new Date(surgeryDate.setHours(0, 0, 0, 0)) ===
                    new Date(selectedDate).setHours(0, 0, 0, 0)
                );
            });

        if (indexOfSurgeryDateAfterSelectedDate === -1) {
            indexOfSurgeryDateAfterSelectedDate =
                viewDataSurgeryDates.findIndex((surgeryDate) => {
                    return (
                        new Date(surgeryDate.setHours(0, 0, 0, 0)) >
                        new Date(selectedDate).setHours(0, 0, 0, 0)
                    );
                });
        } else {
            indexOfSurgeryDateAfterSelectedDate += 1;
        }

        let tempStartDate =
            viewDataSurgeryDates[indexOfSurgeryDateAfterSelectedDate];
        const newStartDate = tempStartDate;

        const newEndDate =
            new Date(newStartDate).setHours(0, 0, 0, 0) >=
            new Date().setHours(0, 0, 0, 0)
                ? getEndOfTimeDate()
                : getEndDateForStartDate(tempStartDate, 0);
        dispatch(
            setFilters({
                startDate: convertDateToISOString(
                    new Date(newStartDate),
                    'start'
                ),
                endDate: convertDateToISOString(new Date(newEndDate), 'end'),
            })
        );
        dispatch(setSelectedDate(new Date(newStartDate)));
    };

    const ordersHeaderContentHandler = (date) => {
        const dateObject = new Date(date);
        const fullDate =
            dateObject.getDate() +
            ' ' +
            getShortMonthName(dateObject.getMonth()) +
            ' ' +
            dateObject.getFullYear();
        const day = ' - ' + getFullDayName(dateObject.getDay());

        return (
            <OrderDateCaseHeader
                key={fullDate}
                searchParam={searchParam}
                selectedDate={dateObject}
                day={day}
                totalCase={
                    orders.filter(
                        (order) =>
                            order.surgeryStartDateAtMidnight.toDateString() ===
                            date
                    ).length
                }
                isToday={date === new Date().toDateString()}
            />
        );
    };

    const scheduleSurgeryContentHandler = () => {
        let currentStartofDay = new Date(currentDate.setHours(0, 0, 0, 0));
        currentStartofDay = new Date(currentStartofDay);
        // const isSelectedDateWithinLastThreeBusinessDateOrFutureDate =
        //     businessDays.includes(selectedDate.valueOf()) ||
        //     selectedDate.valueOf() >= currentStartofDay.valueOf();
        const isSelectedDateWithinLastThreeBusinessDateOrFutureDate =
            selectedDate.valueOf() >= businessDays[0];

        return (
            <NoCaseScheduleSurgery
                key={currentStartofDay}
                showAddSurgeryButton={
                    isSelectedDateWithinLastThreeBusinessDateOrFutureDate
                }
            />
        );
    };

    const contentHandler = (date) => {
        return (
            <OrderContainer key={date}>
                {orders
                    .filter(
                        (order) =>
                            order.surgeryStartDateAtMidnight.toDateString() ===
                            date
                    )
                    .map((order) => {
                        return <Order key={order?.myCaseRef} {...order} />;
                    })}
            </OrderContainer>
        );
    };

    let content = [];
    if (!isSelectedDateGtFromCurrentDate) {
        content.push(
            ordersHeaderContentHandler(new Date(selectedDate).toDateString())
        );
        content.push(
            !isSelectedDateHaveOrders &&
                scheduleSurgeryContentHandler(
                    new Date(selectedDate).toDateString()
                )
        );
        content.push(contentHandler(new Date(selectedDate).toDateString()));
    } else {
        content.push(
            ordersHeaderContentHandler(new Date(selectedDate).toDateString())
        );
        content.push(
            !isSelectedDateHaveOrders &&
                scheduleSurgeryContentHandler(
                    new Date(selectedDate).toDateString()
                )
        );
        content.push(contentHandler(new Date(selectedDate).toDateString()));

        const futureOrders = orders.filter((order) => {
            return (
                new Date(
                    order.surgeryStartDateAtMidnight.setHours(0, 0, 0, 0)
                ).getTime() >
                new Date(selectedDate.setHours(0, 0, 0, 0)).getTime()
            );
        });
        let previousDate = new Date(selectedDate);

        for (let i = 0; i < futureOrders.length; i++) {
            const surgeryStartDate = new Date(
                futureOrders[i].surgeryStartDateAtMidnight.setHours(0, 0, 0, 0)
            ).getTime();
            if (
                new Date(previousDate.setHours(0, 0, 0, 0)).getTime() !==
                surgeryStartDate
            ) {
                content.push(
                    ordersHeaderContentHandler(
                        futureOrders[
                            i
                        ].surgeryStartDateAtMidnight.toDateString()
                    )
                );
                content.push(
                    contentHandler(
                        futureOrders[
                            i
                        ].surgeryStartDateAtMidnight.toDateString()
                    )
                );
            }

            previousDate = futureOrders[i].surgeryStartDateAtMidnight;
        }
    }

    const searchParamPresent = () => {
        if (searchParam !== '')
            return {
                visibility: 'hidden',
            };
        else
            return {
                visibility: 'visible',
            };
    };
    const { orderSummaryModal } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const closeCardPreviewHandler = () => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        props.openSearchModal();
        dispatch(setItemListView(false));
    };

    return (
        <>
            <>
                <>
                    {searchParam === '' ||
                    window.innerWidth > sizes.mobileDevice ? (
                        <OrdersContainer
                            filterCount={props.isFiterPanelExits}
                            minHeight={cardDataLoading ? '830px' : '600px'}
                            scrollBarWidth={'8px'}
                        >
                            {!cardDataLoading ? (
                                content.length !== 0 && content
                            ) : (
                                <>
                                    <div style={{ height: '200px' }}>
                                        <Spinner
                                            id="home-ordersCardView-ordersCardView-cardDataLoadingSpinner"
                                            animation="border"
                                            variant="primary"
                                            small
                                        ></Spinner>
                                    </div>
                                </>
                            )}
                        </OrdersContainer>
                    ) : (
                        <OrdersContainer
                            filterCount={props.isFiterPanelExits}
                            minHeight={
                                searchCardDataLoading ? '830px' : '650px'
                            }
                        >
                            {!searchCardDataLoading ? (
                                <>
                                    <SearchResultsPanel />
                                    <OrdersSearchResults
                                        searchOrdersResult={searchCardData}
                                    />
                                </>
                            ) : (
                                <div style={{ height: '200px' }}>
                                    <Spinner
                                        id="home-ordersCardView-ordersCardView-searchCardDataLoadingSpinner"
                                        animation="border"
                                        variant="primary"
                                        small
                                    ></Spinner>
                                </div>
                            )}
                        </OrdersContainer>
                    )}
                </>
                {searchParam != ''
                    ? null
                    : (!isLastOrder || !isSelectedDateGtFromCurrentDate) &&
                      viewDataSurgeryDatesReducer.length > 0 && (
                          <BottomNavigation style={searchParamPresent()}>
                              <BottomBar isLastOrder={isLastOrder}>
                                  {!isLastOrder && (
                                      <span style={searchParamPresent()}>
                                          {!(
                                              isAdditionalViewDataLoading ||
                                              isViewDataLoading
                                          ) ? (
                                              <Button
                                               id={'orders-nocaseschedulesurgery-schedulesurgerylabel-button'}
                                             // id={'orders-orderscardview-previouslabel-button'}
                                                  //secondary
                                                  variant={ButtonStyles?.secondary}
                                                  width="5.625rem"
                                                  height="1.875rem"
                                                  padding="0.625rem"
                                                  fontSize="13px"
                                                  clicked={
                                                      previousButtonHandler
                                                  }
                                                  show={true}
                                              >
                                                  <div
                                                      style={{
                                                          width: '20px',
                                                          height: '24px',
                                                      }}
                                                  >
                                                      <img
                                                          src={ArrowLeft}
                                                          width="auto"
                                                          height="auto"
                                                      />
                                                  </div>

                                                  <div>
                                                      {t(
                                                          'calendar.orders.previousLabel'
                                                      )}
                                                  </div>
                                              </Button>
                                          ) : (
                                              <></>
                                          )}
                                      </span>
                                  )}
                                  {!isSelectedDateGtFromCurrentDate &&
                                  !showNextButton ? (
                                      <span style={searchParamPresent()}>
                                          {!(
                                              isAdditionalViewDataLoading ||
                                              isViewDataLoading
                                          ) ? (
                                              <Button
                                                  //secondary
                                                  id={'orders-orderscardview-nextlabel-button'}
                                                  variant={ButtonStyles?.secondary}
                                                  width="5.625rem"
                                                  height="1.875rem"
                                                  padding="0.625rem"
                                                  fontSize="13px"
                                                  fontFamily="AvenirNextWorld Demi"
                                                  clicked={nextButtonHandler}
                                                  show={true}
                                                  style={searchParamPresent()}
                                              >
                                                  <div>
                                                      {t(
                                                          'calendar.orders.nextLabel'
                                                      )}
                                                  </div>
                                                  <div
                                                      style={{
                                                          width: '20px',
                                                          height: '24px',
                                                      }}
                                                  >
                                                      <img
                                                          src={ArrowRight}
                                                          width="auto"
                                                          height="auto"
                                                      />
                                                  </div>
                                              </Button>
                                          ) : (
                                              <></>
                                          )}
                                      </span>
                                  ) : (
                                      <></>
                                  )}
                              </BottomBar>
                          </BottomNavigation>
                      )}
            </>
            <OrderDetails
                showOrderListDetails={orderSummaryModal}
                orderListDetailsClose={closeCardPreviewHandler}
                fromCalendar={true}
                fromListScreen={false}
            />
        </>
    );
};

export default OrdersCardView;
